var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showFilter
        ? _c("new-filter", {
            ref: "filters",
            staticClass: "eu-width_100",
            attrs: {
              origin: "orders",
              sendFilterEvents: "",
              options: _vm.filterOptions,
              placeholder: _vm.inputConfig.placeholder,
              shortcutProp: _vm.inputConfig.shortcuts,
              showShortcutCustomer: false,
              additionalOptions: _vm.additionalOptions,
              action: _vm.action,
              loadingList: _vm.isLoading,
              totalListItems: _vm.totalItems,
            },
          })
        : _vm._e(),
      _c("section", { staticClass: "el-section" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-container _highlight_header _header_spaced _footer_spaced_sm",
          },
          [
            _vm.isLoading
              ? _c(
                  "section",
                  { staticClass: "eu-pa_6 eu-align_center" },
                  [_c("emd-loader", { attrs: { type: "_invert" } })],
                  1
                )
              : _c("payment-links-table", {
                  attrs: {
                    action: _vm.action,
                    isLoading: _vm.isLoading,
                    items: _vm.items,
                    pagination: _vm.pagination,
                    totalItems: _vm.totalItems,
                  },
                }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }